import * as React from "react";

function SvgCwdChatAssistantIcon(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" stroke="#1A5560" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" {...props}><path d="M8 9h8M8 13h5M12 21l-.5-.5L9 18H6a3 3 0 01-3-3V7a3 3 0 013-3h12a3 3 0 013 3v4.5" /><path d="M15 18a3 3 0 106 0 3 3 0 10-6 0M20.2 20.2L22 22" /></svg>;
}

export default SvgCwdChatAssistantIcon;